import React, {useState} from "react";
import {useIntl} from "umi";
import {Dropdown} from "tea-component";
import {NumberSelect} from "@/pages/datalab/components/SortableDrag/select/type_select";
import {DBColumnType} from "@/pages/datalab/components/SortableDrag/typeDefine";
import {LANGUAGE_EN} from "@home/_config/config";
import classNames from 'classnames';
import { Operation } from '@dbl/core/filter';

const NumberFilter = (props: any, ref: any) => {
  const { onChange, filterInfo, value, setOpenStatus, setVisibleScope, innerFilterValueMapRef } = props;
  // setNumberValue 主要用于在非受控时 触发数值筛选器内部渲染
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [_, setNumberValue] = useState<any>(null);
  
  const { locale, formatMessage } = useIntl();
  const isEn = locale === LANGUAGE_EN;
  const filterValue = value ?? innerFilterValueMapRef?.current?.[filterInfo?.i] ?? {}; // value有值的时候说明是受控
  
  // numberValue, isEmpty, buttonContent 每一次 修改都需要触发重新计算, 所以就不需要useMemo
  const numberValue = {
    column_value: filterValue?.value,
    operation: filterValue?.operation,
    column_type: filterInfo?.otherInfo?.columnType,
  };
  
  const isEmpty = numberValue?.column_value?.length === 0 && numberValue?.operation !== Operation.NotNul && numberValue?.operation !== Operation.Null;
  
  const buttonContent = isEmpty ? formatMessage({id: 'dbl_create_dashboard_default_value_placeholder'}) : DBColumnType.getFilterText(numberValue, isEn);
  
  
  
  return (<Dropdown
    ref={ref}
    className={'dbl-filter-drag-number'}
    boxClassName={'dbl-filter-drag-number-box'}
    button={(<>
      <span className={'dbl-select-button-text'}>{filterInfo?.filterName ?? ''}</span>
      <span className={classNames('dbl-select-button-value', {'select-placeholder': isEmpty})}>{buttonContent}</span>
      
    </>)}
    appearance={"button"}
    onOpen={() => {
      setOpenStatus?.(true);
      setVisibleScope?.(false);
    }}
    onClose={() => {
      setOpenStatus?.(false);
    }}
    clickClose={false}
  >
  
    {
      (close) => (<NumberSelect
        item={numberValue}
        itemOnChange={(columnInfo) => {
          const newValue = {
            ...filterValue,
            value: columnInfo?.column_value ?? [],
            operation: columnInfo?.operation ?? 'greater',
          };
          
          if (innerFilterValueMapRef?.current?.[filterInfo?.i]) { // 说明是报表顶部筛选器, 非受控
  
            innerFilterValueMapRef.current[filterInfo?.i] = newValue;
            const item: any = {
              column_value: newValue?.value,
              operation: newValue?.operation,
              column_type: filterInfo?.otherInfo?.columnType,
            };
            setNumberValue(item);
          } else { // 说明是报表编辑右侧面板 筛选器, 受控
            onChange?.(newValue);
          }
          
        }
        }
        close={close}
      />)
    }
    
  </Dropdown>);
};

export default React.forwardRef(NumberFilter);
